import PropTypes from 'prop-types';
import {
  Navigate,
} from 'react-router-dom';

function PublicRoute({ children }: any) {
  const auth = localStorage.getItem('auth');
  return auth ? <Navigate to="/wellness-services" /> : children;
}

PublicRoute.prototype = {
  children: PropTypes.element,
};

export default PublicRoute;
